import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { defaultTranslateFn } from '../../../utilities';
import { Container, Input } from './styles';

export const FileInput = ({
  accept,
  limit,
  onInput,
  t = defaultTranslateFn,
}: FileInputProps) => {
  const onDrop = useCallback(
    (files: File[]) => {
      const filesToAdd = limit ? files.slice(0, limit) : files;
      onInput(filesToAdd);
    },
    [onInput, limit],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const baseLabel = isDragActive
    ? t('Drop your file(s) here')
    : t('Select one or multiple files');
  const label = !limit ? baseLabel : `${baseLabel} (${t('max')} ${limit})`;

  return (
    <Container {...getRootProps()}>
      <Input {...getInputProps()} accept={accept} />
      <p>{label}</p>
    </Container>
  );
};

export interface FileInputProps {
  limit?: number;
  accept?: string[];
  onInput: (files: File[]) => void;
  t?: (key: string) => string;
}
